import React from 'react'
import vg from "../assets/png2.png"
import {AiFillGoogleCircle, AiFillAmazonCircle, AiFillYoutube, AiFillInstagram } from "react-icons/ai" 


export default function Home() {
  return (
    <>
    <div className='home' id='home'>
        <main>
            <h1>Technical Cube</h1>
            <p>Solution to all your problems</p>
        </main>
    </div>
    <div className="home2">
        <img src={vg} alt='Graphics'/>
    
    <div>
        <p>
            We are your one and only solution to tech problems you face everyday. We are leading tech company whose aim is to increase the problem solving in children.
        </p>
    </div>
    </div>
    <div className="home3" id="about">
        <div>
            <h2>
                Who we are?
            </h2>
            <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem est, sed ullam rem esse quisquam. Autem aperiam sed maiores ullam dolorem fugit sit corporis, earum consequatur! Exercitationem possimus facere iste. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Doloribus ea rerum dignissimos cumque ad maxime aut quibusdam veniam repellendus temporibus est incidunt, hic non nesciunt excepturi magni cupiditate, commodi vel. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Delectus fuga quas nostrum qui eaque, veniam non ducimus, autem accusamus aspernatur vero nobis vel cum. Possimus quidem autem unde necessitatibus explicabo!
            </p>
        </div>
    </div>
    <div className="home4" id='brands'>
        <div>
            <h2>
                Brands
            </h2>
            <article>
                <div style={{animationDelay:"0.3s"}}>
                    <AiFillGoogleCircle/>
                    <p>Google</p>
                </div>
                <div style={{animationDelay:"0.5s"}}>
                    <AiFillAmazonCircle/>
                    <p>Amazon</p>
                </div>
                <div style={{animationDelay:"0.7s"}}>
                    <AiFillYoutube/>
                    <p>Youtube</p>
                </div>
                <div style={{animationDelay:"1s"}}>
                    <AiFillInstagram/>
                    <p>Instagram</p>
                </div>
            </article>

        </div>
        
    </div>
    </>
  )
}
